<template lang="pug">
  include ./../../../mixins
  div(style="height: 100%")
    +b.g-row--appearance_column-xl.--align_center.--justify_around.g-cell.max_height
      share-network(
        v-for="network in networks"
        :network="network.network"
        :key="network.network"
        :style="{backgroundColor: network.color, margin:'7px 0', width:'28px', height:'28px'}"
        :url="sharing.url"
        :title="sharing.title"
        :description="sharing.description"
        :quote="sharing.quote"
        :hashtags="sharing.hashtags"
        :twitterUser="sharing.twitterUser"
      )
        .I(:class="network.icon")
</template>

<script>

export default {
  name: 'ElSocialTool',
  props: {
    shareUrl: String,
    shareTitle: String,
  },
  data() {
    return {
      options: false,
      statusClick: this.statusShow,
      sharing: {
        url: this.shareUrl,
        title: this.shareTitle,
      },
      networks: [
        { network: 'facebook', name: 'Facebook', icon: 'icon--facebook' },
        { network: 'viber', name: 'Viber', icon: 'icon--viber' },
        { network: 'telegram', name: 'Telegram', icon: 'icon--telegram' },
        { network: 'linkedin', name: 'LinkedIn', icon: 'icon--linkedin' },
      ],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/ElSocialTool.vue